import React, { useState, useEffect } from 'react';
import { Col} from 'reactstrap';
import TextField from '../../Components/FormGroup/TextField';
import SelectField from '../../Components/FormGroup/SelectField';
import DateField from '../../Components/FormGroup/DateField';
import { validateEmail } from '../../Components/FormGroup/Validator';
import { maxDriverAgeDate, minDriverAgeDate, noAccidentsOptions, titleOptions } from '../../Components/Constants';
import { ResponsiveRow } from '../../Components/PageComponents';
import { OptionsAPI } from 'API/GeneralAPI';
import { OptionsType } from 'Components/Types';

function AdditionalDriverForm() {

    const [options, setOptions] = useState<OptionsType[]>([]);

    useEffect(() => {
        const getOptions = async () => {
            const response = await OptionsAPI.get("years_passed_test");
            const yearsPassedList = response.map((option: any) => {
                return { value: option["id"], desc: option["description"]};
            });
            setOptions(yearsPassedList);
        }
        getOptions();
    },[])


    return (
        <>
            <ResponsiveRow>
                <Col>
                    <SelectField name={"additional_drivers.0.title"} label={"Title"} required={true} options={titleOptions} />
                </Col>
                <Col>
                    <TextField name={"additional_drivers.0.firstname"} label={"First Name"} required={true} maxlength={35} />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name={"additional_drivers.0.lastname"} label={"Surname"} required={true} maxlength={35} />
                </Col>
                <Col>
                    <DateField name={"additional_drivers.0.dob"} label={"Date of Birth"} required={true} minDate={maxDriverAgeDate} maxDate={minDriverAgeDate} />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name={"additional_drivers.0.email"} label={"Email"} validation={validateEmail} required={true} />
                </Col>
                <Col>
                    <SelectField name={"additional_drivers.0.years_passed_test"} label={"Driving Licence Held"} options={options} removeValue={"no licence"} required={true}/>
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col md={6}>
                    <SelectField name={"additional_drivers.0.number_accidents"} label={"Number of Fault Accidents in the last 5 years"} options={noAccidentsOptions} required={true} />
                </Col>
            </ResponsiveRow>
        </>

    );
}
export default AdditionalDriverForm;
